import { configureStore } from '@reduxjs/toolkit';
import apiLanguage from './api/language';
import apiCommon from './api/common';
import apiBranch from './api/branch';
import apiCompany from './api/company';
import apiPerson from './api/person';
import globalReducer from './slices/global';
import messageReducer from './slices/message';
import pageReducer from './slices/page';

const store = configureStore({
    reducer: {
        [apiBranch.reducerPath]: apiBranch.reducer,
        [apiCommon.reducerPath]: apiCommon.reducer,
        [apiCompany.reducerPath]: apiCompany.reducer,
        [apiLanguage.reducerPath]: apiLanguage.reducer,
        [apiPerson.reducerPath]: apiPerson.reducer,
        global: globalReducer,
        message: messageReducer,
        page: pageReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            apiBranch.middleware,
            apiCommon.middleware,
            apiCompany.middleware,
            apiLanguage.middleware,
            apiPerson.middleware,
        ),
});

// Infer types for use in hooks
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
